// test1471
(1471 && 0);
